import { render, staticRenderFns } from "./CanceledShipment.vue?vue&type=template&id=34c2e63d&"
import script from "./CanceledShipment.vue?vue&type=script&lang=js&"
export * from "./CanceledShipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports